import React, { Component, ReactElement } from 'react'
import { Route } from '../Annotation/Route'
import { RouteID } from '../Components/Molecules/Header/Types/Types'
import { CommonFormContextProvider } from '../../React/Common/Contexts/CommonFormContext'
import { WelcomeContainer } from '../Components/Organisms/WelcomeContainer/WelcomeContainer'
import { PasswordChange } from '../Components/Organisms/PasswordChange/Main/PasswordChange'
import { RouteGuard } from '../Guards/RouteGuard'
import { BaseContexts } from '../../React/Common/BaseContexts'
import { useDisableUserInfoErrors } from '../../React/Common/Hooks/useDisableUserInfoErrors'

@Route(RouteID.RESET_PASSWORD)
export class ResetPasswordPage extends Component {
    render(): ReactElement {
        useDisableUserInfoErrors()

        return (
            <RouteGuard route={RouteID.RESET_PASSWORD}>
                <BaseContexts>
                    <CommonFormContextProvider>
                        <CommonFormContextProvider>
                            <WelcomeContainer>
                                <PasswordChange />
                            </WelcomeContainer>
                        </CommonFormContextProvider>
                    </CommonFormContextProvider>
                </BaseContexts>
            </RouteGuard>
        )
    }
}
